import uniqBy from 'lodash/uniqBy';
export function getConversationFormName(csid) {
    return `conversationForm_${csid}`;
}
export function getConversationFormEmailInitialValues(conversation, fromEmails) {
    var _a, _b, _c, _d, _e, _f;
    if (!((_a = conversation === null || conversation === void 0 ? void 0 : conversation.events) === null || _a === void 0 ? void 0 : _a.length) || !(fromEmails === null || fromEmails === void 0 ? void 0 : fromEmails.length)) {
        return {};
    }
    const requester = conversation.requested_by
        ? (_b = conversation.authors) === null || _b === void 0 ? void 0 : _b[conversation.requested_by]
        : null;
    const messageEvents = (_d = (_c = conversation.events) === null || _c === void 0 ? void 0 : _c.filter((event) => 
    // TODO [CONV-258]:remove the `contactform` exception once the backend fixes the issue with from and to emails.
    (event.channel === 'contactform' || !event.is_auto_reply) &&
        ['conversation:message_added', 'conversation:add_message'].includes(event.type))) !== null && _d !== void 0 ? _d : [];
    const lastMessage = (_e = messageEvents.reverse().find((message) => message.from)) !== null && _e !== void 0 ? _e : null;
    // We try to get the from address from the last message.
    const fromEmail = findEmailIntegration(fromEmails, (_f = conversation.attributes) === null || _f === void 0 ? void 0 : _f.integration_email) || null;
    let to = null;
    let cc = null;
    let bcc = null;
    // We look at the last message in the message event list with a from attribute on.
    if (lastMessage) {
        let toArray = lastMessage.reply_default_to_emails !== undefined
            ? JSON.parse(lastMessage.reply_default_to_emails)
            : null;
        // if there is no cc on the reply_default_to_emails then we look at the to_list_v2.
        if (toArray === null || toArray.length === 0) {
            toArray =
                lastMessage.to_list_v2 !== undefined
                    ? JSON.parse(lastMessage.to_list_v2)
                    : null;
        }
        if (toArray) {
            to = toArray.map(toUser);
        }
        // We need to make the primary requester non-removable (add removable false).
        if (to && requester && requester.email) {
            const userIndex = to.findIndex((to) => to.user && to.user.email && to.user.email === requester.email);
            if (userIndex > -1) {
                // Add non-removable.
                to[userIndex]['removable'] = false;
            }
        }
        const ccArray = lastMessage.reply_default_cc_emails !== undefined
            ? JSON.parse(lastMessage.reply_default_cc_emails)
            : null;
        if (ccArray) {
            cc = ccArray.map(toUser);
        }
        let bccArray = lastMessage.reply_default_bcc_emails !== undefined
            ? JSON.parse(lastMessage.reply_default_bcc_emails)
            : null;
        if (bccArray === null || bccArray.length === 0) {
            bccArray =
                lastMessage.bcc_list_v2 !== undefined
                    ? JSON.parse(lastMessage.bcc_list_v2)
                    : null;
        }
        if (bccArray) {
            bcc = bccArray.map(toUser);
        }
    }
    // We need a fallback to conversation attributes (because of old conversations and contact forms).
    if (to === null) {
        let email = '';
        let name = '';
        let toArray = null;
        if (conversation.attributes &&
            (conversation.attributes.to_email || conversation.attributes.from_email)) {
            email =
                conversation.direction === 'inbound'
                    ? conversation.attributes.from_email
                    : conversation.attributes.to_email;
            toArray = [];
            if ((requester === null || requester === void 0 ? void 0 : requester.name) && requester.email && email === requester.email) {
                name = requester.name;
            }
            toArray.push({ email: email, name: name });
            if (toArray)
                to = toArray.map(toUser);
        }
    }
    return {
        fromEmail,
        to,
        cc,
        bcc,
    };
}
function toUser(email) {
    return { user: email };
}
function findEmailIntegration(fromEmails, fromAddress) {
    if (!fromAddress)
        return null;
    // We check that the from address is one of our email integrations.
    for (const fromEmail of fromEmails) {
        const { email_address, spf_sender_email } = fromEmail;
        if ([email_address, spf_sender_email].includes(fromAddress)) {
            return fromEmail.email_address;
        }
    }
}
export function getUniqueRecipientEmails(values) {
    if (!(values === null || values === void 0 ? void 0 : values.length)) {
        return;
    }
    const emails = values.map(({ user: { email, display_name, name } }) => ({
        email: email || '',
        name: (display_name === null || display_name === void 0 ? void 0 : display_name.trim()) || (name === null || name === void 0 ? void 0 : name.trim()),
    }));
    return uniqBy(emails, ({ email }) => email);
}
